<template>
  <div class="app-content">

  </div>
</template>

<script>

export default {
  name: "zhifu",
  // import引入的组件需要注入到对象中才能使用

  components: {
  },
  data() {
    // 这里存放数据
    return {
      showBuyerContainer: false,
      showPriceDetail: false,
      meetingInfo: {}
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    goHome() {
      this.$router.push("/")
    },

    onNextStep() {
      console.log(this.$refs.childComponent.childData)
      localStorage.setItem("userInfo", JSON.stringify(this.$refs.childComponent.childData))
      if (this.meetingInfo.type == 0) {
        this.$router.push('/querenxinxi')
      } else {
        this.$router.push('/paiweidengji')
      }
    },
    onBridgeReady(wxData) {
      console.log('wxData', wxData);
      const { appId, timeStamp, nonceStr, packageInfo, signType, paySign } = wxData;
      console.log('wxData', appId, timeStamp, nonceStr, packageInfo, signType, paySign);
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: appId,
          timeStamp: timeStamp,
          nonceStr: nonceStr,
          package: packageInfo,
          signType: signType,
          paySign: paySign
        },
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            queryOrder();
            setLoading(false)
          }
        }
      );
    },
    /**
     * 支付
     * @param {*} type
     */
    async wxPayOrder(id) {
      try {
        const data = await wxPayOrderApi(id);
        if (data.success) {
          if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
              document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false);
            } else if (document.attachEvent) {
              document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
              document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
            }
          } else {
            onBridgeReady(data.result);
          }
        }
      } catch (error) { }
    }

  },
  // 生命周期-创建完成（可以访问当前this实例）
  created() {


  },
  // 生命周期-挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, // 生命周期-创建之前
  beforeMount() { }, // 生命周期-挂载之前
  beforeUpdate() { }, // 生命周期-更新之前
  updated() { }, // 生命周期-更新之后
  beforeDestroy() { }, // 生命周期-销毁之前
  destroyed() { }, // 生命周期-销毁完成
  activated() { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
.zIndex {
  z-index: 2999 !important;
}
/* 整体内容容器样式 */
.app-content {
  height: 100%;
  width: 100%;
  padding-bottom: 82px;
}

/* 顶部图片样式 */
.top-image {
  height: 101px;
  width: 100%;
  position: absolute;
  margin-top: -16px;
  z-index: -5;
}

/* 注册日期相关样式 */
.reg-date {
  background: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 16px 12px 0;
  margin: 16px 12px;
}

.communion-type {
  min-height: 25px;
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: #000;
  letter-spacing: 0;
}

.communion-type-container {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  letter-spacing: 0;
  font-weight: 400;
  height: 36px;
  line-height: 36px;
}

.use-date-wrap {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 400;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-top: 8px;
  line-height: 48px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.use-date-wrap label {
  width: 68px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  font-family: PingFangSC-Regular, PingFang SC;
}

/* 祈祷信息容器样式 */
.title-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.prayer-title {
  font-size: 16px;
  color: #000;
  font-weight: 700;
  font-family: PingFangSC-Medium, PingFang SC;
  display: inline-block;
  z-index: 2;
}

.item-left,
.item-right {
  width: 10%;
}

.item-middle {
  width: 80%;
}

.card-cell-name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}

.card-cell {
  margin-bottom: 5px;
}

.card-title {
  font-weight: bold;
}

/* 输入框和选择框相关样式 */
.cell {
  margin-bottom: 10px;
}

.text-area {
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 3px;
}

.contact-checkBox {
  margin-top: 10px;
}

.regular-checkbox {
  margin-right: 5px;
}

/* 请购人容器样式 */
.buyer-container {
  border: 1px solid #ccc;
  padding: 20px;
  margin-bottom: 20px;
}

.buyer-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

/* 功德经资容器样式 */
.money-container {
  margin: 16px 12px 0;
  background-color: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 16px 12px 8px;
}

.money-title {
  font-size: 16px;
  color: #000;
  font-weight: 700;
  font-family: PingFangSC-Medium, PingFang SC;
  display: inline-block;
}
.money-container .cell {
  line-height: 48px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-weight: 400;
}
.money-container .cell .label {
  width: 68px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  font-family: PingFangSC-Regular, PingFang SC;
}
/* 底部容器样式 */
.bottom-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 72px;
  background-color: #fff;
  -webkit-box-shadow: inset 0 1px 0 0 #eee;
  box-shadow: inset 0 1px 0 0 #eee;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 32px;
}
.bottom-container .money-wrap .symbol {
  font-size: 14px;
  color: #e65c2e;
  font-weight: 700;
  font-family: HelveticaNeue-Bold, HelveticaNeue;
}
.bottom-container .money-wrap .money {
  font-size: 20px;
  color: #e65c2e;
  font-weight: 700;
  font-family: HelveticaNeue-Bold, HelveticaNeue;
}
.bottom-container .detail-wrap {
  margin: 2px 0 2px 8px;
}
.submit-order2 {
  width: 280px;
  margin: 0 auto;
  height: 40px;
  line-height: 40px;
  background: linear-gradient(133deg, #007aaa, #004e93);
  border-radius: 22px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  -webkit-box-shadow: 0 0 8px 0 rgba(19, 190, 191, 0.2);
  box-shadow: 0 0 8px 0 rgba(19, 190, 191, 0.2);
  font-family: PingFangSC-Regular, PingFang SC;
}
.detail-wrap img {
  margin-left: 5px;
}
.bottom-container .detail-wrap .detail-text {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  font-family: PingFangSC-Regular, PingFang SC;
}
.bottom-container .detail-wrap > img {
  width: 14px;
  height: 14px;
  vertical-align: bottom;
  -webkit-transition: -webkit-transform 0.5s;
  transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
  transition: transform 0.5s, -webkit-transform 0.5s;
}
.submit-order {
  width: 160px;
  height: 40px;
  line-height: 40px;
  background: linear-gradient(133deg, #007aaa, #004e93);
  border-radius: 22px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  -webkit-box-shadow: 0 0 8px 0 rgba(19, 190, 191, 0.2);
  box-shadow: 0 0 8px 0 rgba(19, 190, 191, 0.2);
  font-family: PingFangSC-Regular, PingFang SC;
}

/* 价格明细相关样式 */
.price-detail-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}

.van-popup--bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  min-height: 180px;
  padding: 16px 16px 72px;
  width: auto;
}

.van-popup--bottom img {
  position: absolute;
  right: 16px;
  top: 16px;
  width: 10px;
}

.detail-title {
  font-size: 16px;
  color: #000;
  font-weight: 700;
  font-family: PingFangSC-Medium, PingFang SC;
}
.van-popup--bottom .cell {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 8px;
}
.van-popup--bottom .cell .title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  font-family: PingFangSC-Regular, PingFang SC;
}
.van-popup--bottom .cell .money {
  font-size: 14px;
  color: #000;
  margin-left: auto;
  font-family: PingFangSC-Regular, PingFang SC;
}
.btn-home {
  width: 44px;
  height: 44px;
  background: #fff;
  border: 1px solid #007aaa;
  border-radius: 22px;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: fixed;
  bottom: 106px;
  right: 15px;
  z-index: 999;
}
.img-home {
  width: 20px;
  height: 20px;
}
.text-home {
  font-size: 10px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #007aaa;
}
</style>